<script setup lang="ts">
import { SSLyricVideoIndex } from "@/models/frontend-only/LyricVideos";

const store = useSongStore();
defineProps<{
  data: SSLyricVideoIndex | null;
}>();
</script>

<template>
  <section v-if="data">
    <SectionTitle :placeholder="store.placeholderNotLoaded"
      >Related Lyric Video
      <span class="text-xs font-bold uppercase italic text-primary">{{
        $t("SV.LIT_Beta")
      }}</span></SectionTitle
    >

    <router-link :to="`/lyric-videos/videos/${data.videoId}`">
      <LVThumbnail
        :title="data.title"
        :song-length-seconds="data.duration"
        :tag="data.tags"
        :force-background-index="data.slideBackground"
      />
      <div class="py-1 font-display font-semibold uppercase text-primary">
        View Video <i class="fa-light fa-chevron-right" />
      </div>
    </router-link>
  </section>
</template>

<style scoped lang="postcss"></style>
